import { useTranslation } from 'react-i18next';
import Back1 from '../assets/images/back-home-1.webp';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import ContactPage from '../pages/ContactPage';
//import logoImage from '../assets/images/stp.svg';

export const Contact = () => {
  //const absoluteImageUrl = require.resolve(logoImage);
  const { t, i18n } = useTranslation();

  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("¡Transformamos tu financiera desde el Core!")}
        description={t("Descubre nuestra plataforma de tecnología financiera con soluciones innovadoras que van más allá del core bancario. Contáctanos y transforma tu negocio.")}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        isContact={true}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/contact' : 'contacto'}`}
        hreflang={[
          { url: "https://dynamicore.io/contacto", lang: "es" },
          { url: "https://dynamicore.io/en/contact", lang: "en-us" }
        ]}
      />
      <ContactPage/>
    </Layout>
  );
};
